"use client";

import React from "react";
import { Icon } from "@ospweb/sdk-ui";
import { cn } from "utils";
import { useMemoizedFn } from "ahooks";
import Translations from "@translate/components/Portfolio/Header/AddAssetsButton/AddAssetsButton";
import { I18nUtil } from "@utils/i18n";
import { useIsPc } from "@/src/hooks";
import { MenuSearchModalCreateAble } from "@/src/components/Menu/MenuSearchModal";

const I18n = I18nUtil.createScoped(Translations);

export interface AddAssetsButtonProps {
  /** 额外样式类 */
  className?: string;
  /** 是否禁用 */
  disabled?: boolean;
  /** 文案（可国际化注入） */
  label?: string;
}

export const AddAssetsButton: React.FC<AddAssetsButtonProps> = ({
  className,
  disabled = false,
}) => {
  const [isPc] = useIsPc();

  const handleClick = useMemoizedFn(async () => {
    await MenuSearchModalCreateAble({
      type: "portfolio",
    });
  });
  return (
    <button
      aria-label="Add Assets Button"
      data-openreplay-label="Add Assets Button Button"
      id="btn-add-assets-button"
      type="button"
      className={cn(
        "md:secondary_button tonal_button md:bg-transparent",
        "md:sm_button xs_button",
        "md:px-2 px-[6px]",
        "button_m text-content_primary gap-1",
        className,
      )}
      onClick={handleClick}
      disabled={disabled}
      data-testid="add-assets-button"
    >
      <Icon
        name="folder-plus"
        size={isPc ? 20 : 16}
        className="md:text-content_primary text-content_tertiary"
      />
      <span className="button_m text-content_primary hidden md:block">
        {I18n.t("Add Assets")}
      </span>
    </button>
  );
};
